import React, { PureComponent } from 'react';
import Card from 'ui/card';
// Components

interface ListProps {}
export default class List extends PureComponent<ListProps> {
  render() {
    return (
      <div className="center-content">
        <Card className="margin">
          <h1>PArts</h1>
        </Card>
      </div>
    );
  }
}
